import * as React from "react";
import { Image } from "react-bootstrap";

type ImageWithFallbackProps = {
    src: string;
    fallbackPath: string;
    className: string;
    description?: string;
};

type State = {
    imageExists: boolean;
};

export class ImageWithFallback extends React.Component<ImageWithFallbackProps, State> {
    constructor(props: ImageWithFallbackProps) {
        super(props);
        this.state = { imageExists: true };
    }

    render() {
        const imageUrl = this.state.imageExists ? this.props.src : this.props.fallbackPath;
        return (
            <Image
                className={this.props.className}
                src={imageUrl}
                alt={this.props.description}
                onError={() => {
                    this.setState({ imageExists: false });
                }}
            />
        );
    }
}
